<app-modal-header title="Credits usage" (onClose)="dialogRef.close()"></app-modal-header>

<mat-dialog-content>
  <div class="space-y-4 py-1">
    <!-- Intro -->
    <p class="text-sm leading-relaxed text-gray-500">
      Some charges may apply for third-party services Onion manages on your behalf — AI, data enrichment,
      scraping, or email validation. Any available balance and monthly top-ups are used first; only the
      remaining amount is billed at the end of your billing period.
    </p>

    <!-- API key note -->
    <div class="flex items-start gap-2 rounded-control border border-gray-200 bg-gray-100 px-3 py-2.5 text-xs leading-relaxed text-gray-500">
      <svg class="mt-0.5 h-4 w-4 shrink-0 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
      <span>Services using your own API keys are never charged by Onion.</span>
    </div>

    <!-- Cost breakdown -->
    <div class="overflow-hidden rounded-control border border-gray-200">
      <div class="flex items-center justify-between bg-gray-100 px-4 py-2.5 text-xs font-semibold uppercase tracking-wide text-gray-400">
        <span>Feature</span>
        <span>Total cost</span>
      </div>

      <div class="divide-y divide-gray-200">
        <ng-container *ngFor="let v of vendors">
          <div *ngIf="data.additionalCost[v.key]" class="flex items-center justify-between px-4 py-2.5 text-sm">
            <span class="text-gray-600">{{ v.displayName }}</span>
            <span class="font-medium tabular-nums text-gray-700">€{{ data.additionalCost[v.key] | number:'1.2-4' }}</span>
          </div>
        </ng-container>

        <div *ngIf="!data.additionalCost.total" class="px-4 py-8 text-center text-sm text-gray-400">
          No additional costs yet for this period.
        </div>
      </div>
    </div>

    <!-- Summary -->
    <div *ngIf="data.additionalCost.total" class="space-y-2 px-1 text-sm">
      <div *ngIf="data.availableCredits || data.recurrentCredits" class="flex items-center justify-between text-gray-500">
        <span>Subtotal</span>
        <span class="tabular-nums">{{ data.additionalCost.total | currency:'EUR' }}</span>
      </div>
      <div *ngIf="data.availableCredits" class="flex items-center justify-between text-gray-500">
        <span>Available credits</span>
        <span class="tabular-nums">−{{ data.availableCredits | currency:'EUR' }}</span>
      </div>
      <div *ngIf="data.recurrentCredits" class="flex items-center justify-between text-gray-500">
        <span>Recurrent credits top-up</span>
        <span class="tabular-nums">−{{ data.recurrentCredits | currency:'EUR' }}</span>
      </div>
      <div class="mt-1 flex items-center justify-between border-t-2 border-gray-200 pt-3 text-base font-bold text-primary-700">
        <span>Total due</span>
        <span class="tabular-nums">{{ finalTotal | currency:'EUR' }}</span>
      </div>
      <p *ngIf="remainingCredits" class="text-right text-[11px] text-gray-400">
        {{ remainingCredits | currency:'EUR' }} in credits remaining
      </p>
    </div>
  </div>
</mat-dialog-content>
